<template lang="pug">
  .height-100
    .display-flex.mb-5
      .volver.display-flex.flex-1
        button.button(@click="volver()")
          span.icon
            i.fa.fa-arrow-left
          span Volver
    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .box.lista-solicitud-vacaciones.contenedor-interno(key="box-cajas")
        .contenedor-glosa.mb-0
          h4.titulo
            strong {{ titulo }}
          br
          h3.organizador Organizador: {{ nombreCreador }}
          h3.fecha Cuando:  {{ fecha }} {{ horaDesde && horaHasta ? `${horaDesde} - ${horaHasta}` : '' }}
          br
        .contenedor-glosa.flex.cuerpo
          .flex-1
            p.pt-10.descripcion.mb-5(v-html="convertirSaltosDeLinea(descripcion)")

            section(v-if="salaTitulo")
              h1.tipo Lugar
              h3.titulo Sala: {{ salaTitulo }}
              template(v-if="salaDescripcion")
                p.pt-10.descripcion(v-html="convertirSaltosDeLinea(salaDescripcion)")
            section.contenedor-glosa(v-if="link")
              a(:href="link", target="_blank") Ingresar a {{ tipo === 'reunion' ? 'la reunión' : 'la capacitación' }}
          .asistentes
            h1.tipo.mb-10 Asistentes
            .lista.overflow-y-scroll
              .asistente-item(v-for="(o, index) in asistentes")
                h3.nombre {{ o.nombre || o.nombreExterno }}
                span.cargo {{ o.cargo  || o.cargoExterno }}
                span.externo-span(v-if="o.externo") &nbsp (Externo)
        template(v-if="estado === 0 && codigoCreador !== codigo")
          button.button.is-small.is-success.mr-5(@click="marcarAsitencia(1)")
            span.icon.is-small
              i.fa.fa-thumbs-o-up.is-small
            span Asistí
          button.button.is-small.is-danger(@click="marcarAsitencia(0)")
            span.icon.is-small
              i.fa.fa-thumbs-o-down.is-small
            span No asistí
        h2(v-if="asistio !== null && fechaMarcaAsistio") Marcó {{ asistio ? 'sí' : 'no' }} asistió : {{ fechaMarcaAsistio }}
        .contenedor-glosa(v-if="minutaLink || minutaDescripcion")
          h1.tipo Minuta
          p.pt-10.descripcion(v-if="minutaDescripcion" v-html="convertirSaltosDeLinea(minutaDescripcion)")
          a(v-if="minutaLink" :href="minutaLink", target="_blank") Ver minuta
</template>
<script>
import { apiGet, apiPut, notify } from '../util/general';
export default {
  name: 'reunion-vista-detallada',
  data () {
    return {
      titulo           : '',
      descripcion      : '',
      nombreCreador    : '',
      estado           : 0,
      tipo             : '',
      modalidad        : '',
      link             : '',
      sala             : '',
      fecha            : '',
      horaDesde        : '',
      horaHasta        : '',
      minutaDescripcion: '',
      minutaLink       : '',
      salaTitulo       : '',
      salaDescripcion  : '',
      asistio          : null,
      fechaMarcaAsistio:'',
      codigoCreador: '',
      asistentes:[],
      codigo: +localStorage.getItem('codigo')
    }
  },
  computed: {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    },
    idReunion () {
      return +this.$route.params.idReunion
    }
  },
  components: {
  },
  mounted () {
    this.fetch()
    this.fetchAsistentes()
  },
  methods: {
    convertirSaltosDeLinea (texto) {
      return texto ? texto.replace(/\n/g, '<br>') : '';
    },
    volver () {
      var vm = this
      vm.$router.push('/mis-reuniones')
    },
    close (prop) {
      this[prop] = false
    },
    fetchAsistentes () {
      var vm = this
      vm.isLoading = true
      apiGet(vm, '/reunion/gestion/' + vm.idReunion + '/asistente', {}, function (data) {
        vm.asistentes = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      apiGet(vm, '/reunion/gestion/' + vm.idReunion, {esVistaDetallada: true}, function (data) {
        Object.keys(vm).forEach(function (key) {
          if (data.reunion[key]) vm[key] = data.reunion[key]
        })
        if (data.reunion.asistio === 1 || data.reunion.asistio === 0) {
          vm.asistio = data.reunion.asistio
        } else {
          vm.asistio = null
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    marcarAsitencia (asisti) {
      var vm = this
      vm.isLoading = true
      apiPut(vm, '/reunion/gestion/' + vm.idReunion + '/asistente/marcar-asistencia/mi-asistencia', {asisti}, function (data) {
        notify(vm, 'success', 'Éxito', 'Se ha marcado la asistencia correctamente')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
        vm.fetch()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .externo-span
    color #be8fe4

  .nombre
    font-size 15px
    // color #666
  .cargo
    font-size 12px
    color #666
  .asistentes
    border-left: 1px solid #cbcbcb
    padding-left: 10px
    margin-left: 10px
    .lista
      max-height: 500px;
    // overflow-y: auto;
  .asistente-item
    margin-top 5px
    border-bottom: 1px solid #cbcbcb
    &:last-child
      border-bottom: none
  .contenedor-glosa
    text-align left
    // margin-top 1em
    margin-bottom 3em
    .tipo
      font-size 2em
    .titulo
      font-size 1.7em
    .descripcion
      font-size 16px
  .mb-0
    margin-bottom: 0px !important
  .descripcion
    text-align: left
    font-size: 16px
  .caja
    display: block;
    padding: 0.5rem;
  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding-left 10px
      padding-bottom 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        max-width 25%
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .table
    font-size 13px

  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000
      &.white
        background-color #ffffff

  .status-container-filtro
    display flex
    justify-content center
    align-items center
    .status
      margin 5px
      cursor pointer
      .circle
        transition all ease-in .15s
        width: 30px;
        height: 30px;
      &.selected
        .circle
          border 2px solid #565cde
  .is-mobile
    display none
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      word-wrap: break-word;
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px
  .modal-sidebar-desktop-open
    width: calc(100% - 180px);
  @media (max-width 985px)
    .is-mobile
      display block

    .is-desktop
      display none
  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
  @media (max-width: 500px)
    .caja
      width: 100%;

  @media (max-width: 700px)
    .cuerpo
      display flex
      flex-direction: column
    .asistentes
      border-left: 0px solid #cbcbcb
      padding-left: 0px
      margin-left: 0px
      margin-top: 10px
      .lista
        max-height: 300px;
</style>



// WEBPACK FOOTER //
// View_Reunion_Vista_Detallada.vue?71dac2c5